import React, { useContext, useEffect, useState } from 'react'
import LoggedInUi from './LoggedInUi'
import { makeAuthenticatedGETRequest } from '../utils/endPointCalling'
import ProfileCard from '../Components/Shared/ProfileCard';
import modalContext from '../context/ModalContext';
import SearchBar from '../Components/Shared/SearchBar';
import MarqueeExample from '../Components/MarqueeExample';

function Dashboard() {
    const [userData, setUserData] = useState([]);
    const {showModal, setShowModal} = useContext(modalContext);
    const {modalDetails, setModalDetails} = useContext(modalContext);
    const [searchInput, setSearchInput] = useState("");
    const [showMsg, setShowMsg] = useState(false);

    const searchUser = async () => {
        const response = await makeAuthenticatedGETRequest('/feature/search/user/'+searchInput);
        setUserData(response.data);
    }
    const getData = async () => {
        const response = await makeAuthenticatedGETRequest('/ques/get/details');
        setUserData(response);
    }
    useEffect(()=>{
        getData();
    },[]); 
  return (
    <LoggedInUi>
         <div className='text-black font-bold w-full h-[20%] flex justify-center my-[0.5vmax] items-center text-[3vmax]'>DASHBOARD</div>
         <div className='flex flex-col justfy-center items-center' onKeyDown={(e)=>{
            if(e.key=='Enter'){
                setShowMsg(true);
                searchUser();
            }
         }}><SearchBar doSearch={()=>{searchUser();
            setShowMsg(true);
         }} value={searchInput} setValue={setSearchInput} label='Search' placeholder='Enter Name' />{showMsg && <button onClick={(e)=>{
            e.preventDefault();
            setSearchInput("");
            setShowMsg(false);
            getData();
         }} style={{backgroundColor: '#5E376D'}} className='text-white w-[10vmax] font-bold text-[1.2vmax] my-[1vmax] p-[0.5vmax] rounded-[0.5vmax] bg-white'>Reset Search</button>}</div> 
         {showMsg && <div className='text-black w-full flex justify-center items-center text-[1.2vmax] font-semibold py-[1vmax]'>{userData && userData.length>0 ? `Showing Result for: "${searchInput}"` : `Nothing to show, please modify your search!!`}</div>}
        <div className='flex flex-wrap justify-center px-[2vmax] gap-[2vmax]'>
        {userData && userData.length>0 && userData.map((item)=>{
            return <div className='w-[30vmax]'><ProfileCard item={item} viewDetails={()=>{
                setShowModal(true);
                setModalDetails(item);
            }} /></div>
        })}
        </div> 
        
    </LoggedInUi>
  )
}

export default Dashboard